// @flow
import { isString } from "voca";

export default (provider: string, sym: symbol) => {
	let storage = null;

	const getFakeStorage = () => {
		let items = {};

		return {
			_fake: true,
			setItem: (key, val) => items[key] = val,
			removeItem: (key) => {
				if (Object.prototype.hasOwnProperty.call(items, key)) {
					delete items[key];
				}
			},
			getItem: (key) => (Object.prototype.hasOwnProperty.call(items, key) ? items[key] : null),
			clear: () => {
				items = {};
			},
		};
	};

	const getStorage = () => {
		if (!storage) {
			try {
				if (provider in self) {
					storage = self[provider];
					const key = "__ssTest";
					storage.setItem(key, "xx");
					storage.removeItem(key);
				}
			} catch (ex) {
				storage = null;
			} finally {
				if (!storage) {
					storage = self[sym] = getFakeStorage();
				}
			}
		}

		return storage;
	};

	const setItem = (key: string, value: any) => {
		if (!isString(value)) {
			value = JSON.stringify(value);
		}

		return getStorage().setItem(key, value);
	};

	const removeItem = (key: string) => getStorage().removeItem(key);

	const getItem = (key: string) => getStorage().getItem(key);

	const clear = () => getStorage().clear();

	const isFake = () => !!getStorage()._fake;

	return {
		setItem,
		removeItem,
		getItem,
		clear,
		isFake,
	};
};
